import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IBucketPayloadType } from "../../../types/api/filling-management";

export async function fillingManagementListUsers(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IBucketPayloadType[]>>> {
  return axios.get(API_ENDPOINTS.FILLING_MANAGEMENT_LIST, {
    params: qData,
  });
}

export async function fillingManagementDetails(
  _id: string
): Promise<AxiosResponse<TResponseWithQData<IBucketPayloadType>>> {
  return axios.get(`${API_ENDPOINTS.FILLING_MANAGEMENT_DETAILS}/${_id}`);
}


export async function sendReminder(data: {
  userId: string;
}): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(`${API_ENDPOINTS.SEND_REMINDER}`, data);
}

export async function updateApprovalStatus(data: {
  bucketId: string;
  status: string;
}): Promise<AxiosResponse<TResponse<IBucketPayloadType>>> {
  return axios.patch<TResponse<IBucketPayloadType>>(
    `${API_ENDPOINTS.FILLING_MANAGEMENT_UPDATE_APPROVAL_STATUS}/${data.bucketId}`,
    { status: data.status }
  );
}
